import { ownTractorSurveySteps } from './ownTractorSurveyBrand';

export const ownTractorSurveyConstants = {
  steps: ownTractorSurveySteps,
};
